import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=fe11b132&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=fe11b132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe11b132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe11b132')) {
      api.createRecord('fe11b132', component.options)
    } else {
      api.reload('fe11b132', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=fe11b132&scoped=true&", function () {
      api.rerender('fe11b132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xXrqMrAPeEQi/JS/comp/PopupBox.vue"
export default component.exports